import m from "mithril";
import { uploadSvc } from "../services/upload.service";
import { PortalForm } from "../types/portal-form.interface";
import { Form } from "./Form";

// :)
const SPECIAL_JAMIE_MESSAGE = "";

export const Portal: m.Component<{}, {
  errorMsg: () => string,
  isUploading: boolean,
  isUploaded: boolean,
  portalForm: PortalForm,
  submissionFile: File | null,
  redirectUrl: string,
  performUpload: () => void,
}> = {

  oninit() {

    this.errorMsg = () => {
      if (!this.portalForm.projectName) return `Please enter a project name`;
      if (!this.portalForm.songName) return `Please enter a song name`;
      if (!this.portalForm.partName) return `Please enter a voice part`;
      if (!this.portalForm.givenName || !this.portalForm.familyName) return `Please enter your name`;
      if (!this.portalForm.email) return `Please enter your email address`;
      if (!this.submissionFile) return `Please select your submission file`;
      return ``;
    };

    this.performUpload = async () => {
      this.isUploading = true;

      const uploadUrlResponse = await uploadSvc.getUploadUrl(this.portalForm);
      if (!uploadUrlResponse || !this.submissionFile) {
        this.isUploading = false;
        m.redraw();
        return;
      }

      let uploadedOk: boolean = false;
      if (uploadUrlResponse.uploadType === "multiple") {
        const signedUploadUrls: string[] = [];
        for (let i = 0; i < uploadUrlResponse.uploadPartCount; i++) {
          signedUploadUrls.push(uploadUrlResponse.signedUploadUrls[i]);
        }
        uploadedOk = await uploadSvc.uploadFilePartsToUrls(this.submissionFile, signedUploadUrls, uploadUrlResponse);
      } else {
        uploadedOk = await uploadSvc.uploadFileToUrl(this.submissionFile, uploadUrlResponse.signedUploadUrl);
      }

      if (uploadedOk) {
        this.isUploaded = true;
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl;
        }
      }
      this.isUploading = false;
      m.redraw();
    };

    this.isUploading = false;
    this.isUploaded = false;

    const urlParams = new URLSearchParams(window.location.search);
    const songId: string = urlParams.get("songId") ?? "";
    const projectName: string = urlParams.get("project") ?? "";
    const songName: string = urlParams.get("song") ?? "";
    const partName: string = urlParams.get("part") ?? "";
    const givenName: string = urlParams.get("givenName") ?? "";
    const familyName: string = urlParams.get("familyName") ?? "";
    const email: string = urlParams.get("email") ?? "";
    const useMultiPart: boolean = (urlParams.get("useMultiPart") ?? "false").toLowerCase() === "true";
    this.redirectUrl = urlParams.get("redirectUrl") ?? "";

    this.portalForm = {
      songId,
      projectName,
      songName,
      partName,
      givenName,
      familyName,
      email,
      fileType: "",
      fileExt: "",
      fileSize: 0,
      useMultiPart,
    };
    this.submissionFile = null;

  },

  view() {

    return m(".my-12", [

      m(".flex.justify-center", [

        m(".p-6.flex.flex-col.space-y-4.bg-white.text-gray-800.rounded-lg.shadow", {
          style: `max-width: 600px;`,
        }, [

          m(".flex.justify-center", [
            m("img", {
              width: 200,
              // src: "https://via.placeholder.com/250x150"
              // src: "https://www.stayathomechoir.com/wp-content/uploads/2021/05/cropped-aP-9i_ww-1-1.png",
              src: "https://www.worldchoir.org/wp-content/uploads/2025/06/World-Choir_Logo_BW-1024x463.png",
            }),
          ]),

          m(".text-center", [
            m("h1.my-2.text-2xl.font-semibold", "Submission Portal"),
          ]),

          this.isUploaded ? [

            m("p", "Submission uploaded!"),
            m("p", "Thank you for participating in this project."),

          ] : [

            m(Form, {
              disabled: this.isUploaded || this.isUploading,
              form: this.portalForm,
            }),

            m(".flex.flex-col.space-y-1", [
              m("label.font-semibold", "File to Submit"),

              m("label.flex.items-center.input.space-x-2.cursor-pointer", {
                for: "file-input",
                class: this.isUploading ? "disabled" : "",
              }, [
                // m("i", "upload icon"),
                // m("span.font-mono.font-bold", "⤒"),
                m("i.fas.fa-cloud-upload-alt.text-gray-700"),
                m("span", this.submissionFile ? this.submissionFile.name : "[click to select your file]"),
              ]),

              // m("p.text-sm.text-gray-600", "Select the recording of yourself singing your selected part."),
            ]),

            m("input[type=file].hidden", {
              id: "file-input",
              disabled: this.isUploaded || this.isUploading,
              // value: this.submissionFile,
              onchange: (e: any) => {
                this.submissionFile = e.target.files[0] as File | null;
                if (this.submissionFile) {
                  this.portalForm.fileType = this.submissionFile.type;
                  const nameBits = this.submissionFile.name.split(".");
                  this.portalForm.fileExt = nameBits[nameBits.length - 1];
                  this.portalForm.fileSize = this.submissionFile.size;
                } else {
                  this.portalForm.fileType = "";
                  this.portalForm.fileExt = "";
                  this.portalForm.fileSize = 0;
                }
                console.log("selected", this.submissionFile);
                console.log("form now:", this.portalForm);
              },
            }),

            SPECIAL_JAMIE_MESSAGE ? m("p.text-gray-600", SPECIAL_JAMIE_MESSAGE) : [],

            this.errorMsg()
              ? m("p.text-sm.text-red-700", this.errorMsg())
              : [],

            (this.errorMsg() || this.isUploading)
              ? m("button.btn.bg-gray-500.text-gray-200.cursor-not-allowed", {
                onclick: () => { }, // No op
              }, this.isUploading ? `Uploading Submission... (${uploadSvc.progress})` : "Upload Submission")
              : m("button.btn", {
                onclick: async () => {
                  this.performUpload();
                },
              }, "Upload Submission"),

          ],

        ]),
      ]),

    ]);

  }

};
